import uiPaths from "routes/uiPaths";


export const commonBreadcrumbs = {
  transactionsList: {name: 'All transactions', link: uiPaths.transactionPaths.list.reverse()},
  customersList: {name: 'All customers', link: uiPaths.customerPaths.list.reverse()},
  virtualTerminal: {name: 'Virtual Terminal', link: uiPaths.virtualTerminalPaths.index.reverse()},
};
